import React from 'react';
import classNames from 'classnames';
import styles from './SingleSelectButton.scss.js';
import Icon from '../../../Icons/Icons/Icon/Icon.js';
import { sizeOptions } from '../../../../helpers/enums/themes/sizeOptions.js';

const SingleSelectButton = _ref => {
  let {
    tabIndex = -1,
    onSelect,
    isDisabled,
    isOpen,
    selected,
    icon,
    isFullWidth,
    borderColor = 'light-gray',
    placeholder,
    size = sizeOptions.medium
  } = _ref;
  const handleSelect = e => {
    e.preventDefault();
    onSelect();
  };
  return /*#__PURE__*/React.createElement("button", {
    className: classNames(styles.wrapper, styles[`wrapper--${size}`], {
      [styles['wrapper--full-width']]: isFullWidth,
      [styles[`wrapper--border-color-${borderColor}`]]: true,
      [styles['wrapper--open']]: isOpen,
      [styles['wrapper--placeholder']]: !selected
    }),
    tabIndex: tabIndex,
    disabled: isDisabled,
    onClick: handleSelect
  }, selected?.content || placeholder, icon && /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['wrapper-icon'], {
      [styles['wrapper-icon--open']]: isOpen
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  })));
};
var SingleSelectButton$1 = SingleSelectButton;

export { SingleSelectButton$1 as default };
//# sourceMappingURL=SingleSelectButton.js.map
